module.exports = __webpack_public_path__ + "img/delete2.5cdecb06.png";